"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.victoryEases = void 0;
var victoryEases = ['back', 'backIn', 'backOut', 'backInOut', 'bounce', 'bounceIn', 'bounceOut', 'bounceInOut', 'circle', 'circleIn', 'circleOut', 'circleInOut', 'linear', 'linearIn', 'linearOut', 'linearInOut', 'cubic', 'cubicIn', 'cubicOut', 'cubicInOut', 'elastic', 'elasticIn', 'elasticOut', 'elasticInOut', 'exp', 'expIn', 'expOut', 'expInOut', 'poly', 'polyIn', 'polyOut', 'polyInOut', 'quad', 'quadIn', 'quadOut', 'quadInOut', 'sin', 'sinIn', 'sinOut', 'sinInOut'];
exports.victoryEases = victoryEases;


//////////////////
// WEBPACK FOOTER
// ./~/spectacle/lib/utils/types.js
// module id = 480
// module chunks = 32308089046778